export const DE_LANGUAGE = {
    "ui.vr.start": "VR starten",
    "ui.vr.end": "VR beenden",
    "ui.vr.tooltip.waiting": "Warte auf die HMD-Initialisierung...",
    "ui.xr.notSupported": "WebXR wird nicht unterstützt.",
    "ui.xr.requiresHttps": "WebXR benötigt eine sichere Verbindung.",
    "ui.xr.noImmersiveSession": "VR-Sitzung wird nicht unterstützt.",
    "ui.mic.muted": "Sie sind stummgeschaltet",
    "ui.mic.unmuted": "Ihre Stummschaltung ist aufgehoben",
    "ui.mic.tooltip.mute": "Mikrofon stummschalten",
    "ui.mic.tooltip.unmute": "Stummschaltung aufheben",
    "ui.mic.tooltip.remoteMute": "Alle Teilnehmer stummschalten",
    "ui.mic.tooltip.remoteUnmute": "Stummschaltung von allen Teilnehmern aufheben",
    "ui.editAccount": "Account bearbeiten",
    "ui.logout": "Abmelden",
    "ui.shareSession": "Sitzung Teilen",
    "ui.shareSession.deactivated": "Sitzung ist nicht teilbar",
    "ui.input.positive": "Positiv",
    "ui.input.negative": "Negativ",
    "ui.exitRoom": "Raum verlassen",
    "ui.user.profile": "Benutzer Profil",
    // UI
    "roomEnter": "Raum betreten",
    "roomLoad": "Raum laden",
    "openMenu": "Menü öffnen",
    "openContextMenu": "Objekt Kontextmenü öffnen",
    "gestureMove": "Bewegen",
    // Interactions
    "interaction.transformModel": "Objekt bewegen/skalieren",
    "interaction.transformHandle.rotate": "Objekt drehen",
    "interaction.transformHandle.scale": "Objekt skalieren",
    "interaction.transformHandle.translate": "Objekt bewegen",
    "interaction.flyToHitpoint": "Zum Zielpunk fliegen",
    "interaction.grabbable": "Objekt bewegen",
    "interaction.room.awaitLoading": "Raum wird noch geladen",
    "room.change.rejected.busy": "Raum kann nicht gewechselt werden,\nda grade ein Layout erzeugt wird",
    // Colors
    "black": "Schwarz",
    "grey": "Grau",
    "white": "Weiß",
    "orange": "Orange",
    "yellow": "Gelb",
    "green": "Grün",
    "turquoise": "Türkis",
    "blue": "Blau",
    "magenta": "Magenta",
    "red": "Rot",
    "brown": "Braun",
    // Shapes
    "box": "Box",
    "sphere": "Kugel",
    "cylinder": "Zylinder",
    "cone": "Kegel",
    "pyramid": "Pyramide",
    "prism": "Prisma",
    // Layouts
    "menger.layoutName": "Menger Sponge",
    "random.layoutName": "Random",
    "sysmon.layoutName": "System Monitor",
    "database.layoutName": "Database",
    "projectTree.layoutName": "Controlling",
    "projectTree.geolocation.layoutName": "Controlling\n(GeoLocations)",
    "projectTree.interaction.projectView.reset": "Details ausblenden",
    "projectTree.interaction.projectView.workPerMonth": "Mehr Details anzeigen",
    "projectTree.interaction.projectView.workPerPerson": "Noch mehr Details anzeigen",
    "sandbox.layoutName": "Sandbox",
    "sandbox.ui.room.button.modelCreation": "Objekt\nErstellungs\nOptionen",
    "sandbox.ui.room.button.modelTrasform": "Objekt\nTransformations\nOptionen",
    "sandbox.ui.room.button.record.start": "Aufnahme\nstarten",
    "sandbox.ui.room.button.record.stop": "Aufnahme\nstoppen",
    "sandbox.ui.room.button.replay": "Aufnahme\nabspielen",
    "sandbox.ui.editModel.title": "Objekt bearbeiten",
    "sandbox.ui.editModel.button.label": "Beschriftung",
    "sandbox.ui.editModel.button.shape": "Form ändern",
    "sandbox.ui.editModel.button.color": "Farbe ändern",
    "sandbox.ui.editModel.button.gravity": "Gravitation",
    "sandbox.ui.editModel.button.transform": "Transformieren",
    "sandbox.ui.editModel.button.connection": "Verbindungs Farbe",
    "sandbox.ui.editModel.button.delete": "Löschen",
    "sandbox.ui.connection.title": "Verbindungs Farbe",
    "sandbox.ui.color.title": "Form ändern",
    "sandbox.ui.shape.title": "Form ändern",
    "sandbox.ui.modelCreation.title": "Optionen für Objekt-Erstellung",
    "sandbox.ui.modelCreation.button.shape": "Standard Form ändern",
    "sandbox.ui.modelCreation.button.color": "Standard Farbe ändern",
    "sandbox.ui.modelCreation.button.connection": "Standard Linien Farbe ändern",
    "sandbox.ui.modelCreation.button.room": "Neue Modelle sind Räume",
    "sandbox.ui.modelTrasform.title": "Model Transformations Optionen",
    "sandbox.ui.modelTrasform.button.enableGrid": "an Gitter ausrichten",
    "sandbox.ui.modelTrasform.button.gridSize": "Gitter Größen",
    "sandbox.ui.modelTrasform.button.snapAngle": "Winkel Schrittgröße",
    "sandbox.ui.modelTrasform.button.scaleStepSize": "Skalierungs Schrittgröße",
    "sandbox.ui.gridSize.title": "Gitter Größe",
    "sandbox.ui.snapAngle.title": "Winkel Schrittgröße",
    "sandbox.ui.scaleStepSize.title": "Skalierungs Schritt Größe",
    "sandbox.interaction.createModel": "Objekt erzeugen",
    "hm.button.start": "Start",
    "hm.button.selectProject": "Projekt auswählen",
    "hm.button.releaseSelection": "Selektion freigeben",
    "hm.button.showBackground": "Hintergrund anzeigen",
    "hm.button.exit": "Beenden",
    "YearMonth1": "{year}\nJan.",
    "YearMonth2": "{year}\nFeb.",
    "YearMonth3": "{year}\nMär.",
    "YearMonth4": "{year}\nApr.",
    "YearMonth5": "{year}\nMai",
    "YearMonth6": "{year}\nJun.",
    "YearMonth7": "{year}\nJul.",
    "YearMonth8": "{year}\nAug.",
    "YearMonth9": "{year}\nSep.",
    "YearMonth10": "{year}\nOkt.",
    "YearMonth11": "{year}\nNov.",
    "YearMonth12": "{year}\nDez.",
    "avatar.clothing": "Bekleidung",
    "avatar.headgear": "Kopfbedeckung",
    "avatar.preset": "Voreinstellung",
    "avatar.basecolor": "Grundfarbe",
    "avatar.name.description": "Der Name, mit dem Sie für andere sichtbar sind:", // TODO: wie wäre es hier stattdessen mit "Anzeigename" oder Avatarname?
    "avatar.setup": "  Avatar-Einrichtung",
    "default.button.back": "Zurück",
    "default.button.continue": "Weiter",
    "default.error.message": "  Ein Fehler ist aufgetreten!",
    "mic": "Mikrofon:",
    "mic.access.request.message": "Zugriff auf Ihr Mikrofon wird angefordert.",
    "mic.access.required.message": "Um zu sprechen, müssen Sie den Zugriff auf das Mikrofon erlauben.",
    "mic.activated": "Mikrofon aktiviert",
    "mic.deactivated": "Mikrofon deaktiviert",
    "mic.setup": "Mikrofon-Einrichtung",
    "speakers": "Lautsprecher:",
    "speakers.activated": "Lautsprecher aktiviert",
    "speakers.deactivated": "Lautsprecher deaktiviert",
    "audio.warning": "Um die anderen Teilnehmer zu hören, klicken Sie bitte in das Browserfenster",
    "camera.setup": "Kamera-Einrichtung",
    "camera.access.required.message": "Um Ihre Kamera zu benutzen, müssen Sie den Zugriff auf die Kamera erlauben.",
    "camera.activated": "Kamera aktiviert",
    "camera.deactivated": "Kamera deaktiviert",
    "camera.preview": "Vorschau",
    "api.error.session.name.duplicated": "Der von Ihnen gewählte Name ist bereits vergeben. Bitte beachten Sie, dass zwischen Klein- und Großbuchstaben beim Vergleich nicht unterschieden wird."
};
